import apiClient, { unwrap } from './client'

export interface BlockedDomain {
  domain: string
  note: string
  created_at: string
}

export const blockedDomainsApi = {
  list() {
    return unwrap<BlockedDomain[]>(apiClient.get('/blocked-domains'))
  },
  add(domain: string, note?: string) {
    return unwrap<BlockedDomain>(apiClient.post('/blocked-domains', { domain, note }))
  },
  remove(domain: string) {
    return unwrap<{ deleted: string }>(
      apiClient.delete(`/blocked-domains/${encodeURIComponent(domain)}`),
    )
  },
}
